import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import PasswordResetPage from './components/PasswordResetPage';
import BlogsList from './components/BlogsList';
import BlogDetail from './components/BlogDetail';
import LegalDocumentPage from './components/LegalDocumentPage';
import { LanguageProvider } from './contexts/LanguageContext';
import WebApp from './app/WebApp';

// Sends GA4 page_view for the public pages. The signed-in app reports its own
// virtual /web/app/{page} views from AppShell.
function GARouteTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname || '/';
    const isPublic = path === '/' || path.startsWith('/blogs') || path.startsWith('/privacy-policy') || path.startsWith('/terms-of-service');
    if (!isPublic) return;
    if (path.startsWith('/blogs/')) document.title = 'GymGM - Blog';
    else if (path.startsWith('/blogs')) document.title = 'GymGM - Blogs';
    else if (path.startsWith('/privacy-policy')) document.title = 'GymGM - Privacy Policy';
    else if (path.startsWith('/terms-of-service')) document.title = 'GymGM - Terms of Service';
    else document.title = 'GymGM - Fitness, Nutrition & AI Trainer';
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: `/web${path}${location.search}`,
        page_title: `Web - ${document.title}`,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

// Firebase email action links (password reset) land on /__/auth/action or carry
// ?mode=resetPassword&oobCode=… on any path.
function isPasswordResetLink() {
  const params = new URLSearchParams(window.location.search);
  return window.location.pathname.includes('/__/auth/action') || (params.get('mode') === 'resetPassword' && params.get('oobCode'));
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/blogs" element={<BlogsList />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/privacy-policy/:lang" element={<LegalDocumentPage type="privacy" />} />
          <Route path="/terms-of-service/:lang" element={<LegalDocumentPage type="terms" />} />
          <Route path="/privacy-policy" element={<LegalDocumentPage type="privacy" />} />
          <Route path="/terms-of-service" element={<LegalDocumentPage type="terms" />} />
          <Route path="/*" element={isPasswordResetLink() ? <PasswordResetPage /> : <WebApp />} />
        </Routes>
        <GARouteTracker />
        <Analytics />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
